// extracted by extract-css-chunks-webpack-plugin
module.exports = {"boxItemsContainer":"_3Y23t8","boxItemContainerGrid":"_296DV3","boxLink":"_2VXeuM","boxItem":"FJwFVB","boxIcon":"_1tdxTH","boxTitle":"_2z5_Ol"};